<div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column" *ngIf="mailingObject">
  <div fxLayout="column" fxFlex="70" fxFlex.lt-md="100" fxLayoutGap="15px">
    <mat-card>
      <div fxLayout="row">
        <h3> Email</h3>
      </div>
            <div fxLayout="row"  >
                <app-detail fxFlex="100" header="Do" [value]="mailingObject?.toEmails"></app-detail>

            </div>
<!--      <div fxLayout="row" >-->

<!--          <app-detail fxFlex="100" header="DW:" [value]="mailingObject?.dw"></app-detail>-->

<!--      </div>-->
<!--      <div fxLayout="row"  >-->
<!--          <app-detail fxFlex="100" header="UDW:" [value]="mailingObject?.udw"></app-detail>-->

<!--      </div>-->
      <div fxLayout="row" >

          <app-detail fxFlex="100" header="Tytuł maila" [value]="mailingObject?.title"></app-detail>

      </div>
      <div fxLayout="row">
        <p class="detail-header" >  Treść </p>
      </div>

      <div fxLayout="row" >
        <div fxFlex="100" [innerHTML]="mailingObject?.content"> </div>
      </div>


      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject?.attachments.length > 0  ">
        <div  fxFlex="100">
          <div fxLayout="row" fxLayoutGap="15px" >
            <div fxFlex="100" fxLayout="row">
              <app-detail header="Załączniki">
                <mat-chip-list>
                  <ng-container *ngFor="let attachment of mailingObject.attachments">
                    <mat-chip selected  >

                      {{attachment.fileName}}

                      <button matChipRemove
                              (click)="downloadAttachmentFile(attachment.uuid)">
                        <mat-icon>download</mat-icon>
                      </button>


                    </mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
            </div>
          </div>
        </div>
      </div>
      <!--          <div *ngIf="postObject.attachments" fxLayoutAlign="space-between center" fxFlex="100">-->
      <!--            <img class=" avatar-360" src="/rest/crm/asf360/file/{{formGroup.get('postDetailFileLocation').value}}/image/{{formGroup.get('postDetailFilename').value}}" alt="Zdjęcie"/>-->
      <!--          </div>-->

    </mat-card>

    <mat-card *ngIf="mailingObject?.emailList">
      <div fxLayout="row">
        <h3> Email Lista</h3>
      </div>

      <div fxLayout="row">
        <mat-chip-list>
          <mat-chip *ngFor="let email of mailingObject?.emailList.split(',')">{{ email }}</mat-chip>
        </mat-chip-list>
      </div>



    </mat-card>

  </div>

  <div fxLayout="column" fxFlex="30"  fxLayoutGap="15px">
    <mat-card>
      <div fxLayout="row">
        <h3>Odbiorcy</h3>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Regionalni" [value]="mailingObject.filterByRegional"></app-detail-bool>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.filterByRegional">
        <div fxFlex="100">
          <app-detail>
            <mat-chip-list>
              <ng-container *ngFor="let reg of regional">
                <mat-chip selected>{{reg.fullName}}</mat-chip>
              </ng-container>
            </mat-chip-list>
          </app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Partner" [value]="mailingObject.partner"></app-detail-bool>
        </div>
      </div>



      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Email podstawowy" [value]="mailingObject.basicEmail"></app-detail-bool>

        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Email produktowy" [value]="mailingObject.productEmail"></app-detail-bool>

        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Email konkursowy" [value]="mailingObject.contestEmail"></app-detail-bool>

        </div>
      </div>
      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Email rozliczeniowy " [value]="mailingObject.billingEmail"></app-detail-bool>

        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" *ngIf="mailingObject.partner">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Rejestracja" [value]="mailingObject.registration"></app-detail-bool>

        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner && registrationList.length > 0">
        <div  fxFlex="100">
              <app-detail >
                <mat-chip-list>
                  <ng-container *ngFor="let ic of registrationList">
                    <mat-chip  selected>{{ic.name}}</mat-chip>
                  </ng-container>
                </mat-chip-list>
              </app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner">
        <div fxFlex="100">
          <app-detail header="Status Partnera" [value]="mailingObject.statusPartner?.name"></app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner && contractType!== [] ">


        <div fxFlex="100">
          <app-detail header="Typ umowy Partner">
            <mat-chip-list>
              <ng-container *ngFor="let status of contractType">
                <mat-chip selected>{{status.name}}</mat-chip>
              </ng-container>
            </mat-chip-list>
          </app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner && contractStatus!== [] ">


        <div fxFlex="100">
          <app-detail header="Status umowy Partner">
            <mat-chip-list>
              <ng-container *ngFor="let status of contractStatus">
                <mat-chip selected>{{status.name}}</mat-chip>
              </ng-container>
            </mat-chip-list>
          </app-detail>
        </div>
      </div>


      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.partner">
        <div fxFlex="100">
          <app-detail header="Tagi Partnera" [value]="mailingObject.tagPartner?.name"></app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="OFWCA" [value]="mailingObject.ofwca"></app-detail-bool>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.ofwca">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Email podstawowy" [value]="mailingObject.basicEmailOfwca"></app-detail-bool>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.ofwca">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Email produktowy" [value]="mailingObject.productEmailOfwca"></app-detail-bool>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.ofwca">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Email konkursowy" [value]="mailingObject.contestEmailOfwca"></app-detail-bool>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" *ngIf="mailingObject.ofwca">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Rejestracja" [value]="mailingObject.registrationOfwca"></app-detail-bool>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.ofwca && registrationListOfwca.length > 0">
        <div  fxFlex="100">
          <app-detail >
            <mat-chip-list>
              <ng-container *ngFor="let ic of registrationListOfwca">
                <mat-chip  selected>{{ic.name}}</mat-chip>
              </ng-container>
            </mat-chip-list>
          </app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.ofwca">
        <div fxFlex="100">
          <app-detail header="Tagi Partnera" [value]="mailingObject.tagPartnerOfwca?.name"></app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.ofwca && iddTrainingStatus!== [] ">
        <div fxFlex="100">
          <app-detail header="Statusy szkoleń IDD">
            <mat-chip-list>
              <ng-container *ngFor="let status of iddTrainingStatus">
                <mat-chip selected>{{status.name}}</mat-chip>
              </ng-container>
            </mat-chip-list>
          </app-detail>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px">
        <div  fxFlex="100">
          <app-detail-bool fxFlex="100" header="Pracownicy" [value]="mailingObject.employeeASF24"></app-detail-bool>
        </div>
      </div>

      <div fxLayout="row" fxLayoutGap="15px" *ngIf="mailingObject.employeeASF24">
        <div fxFlex="100">
          <app-detail header="Dział">
            <mat-chip-list>
              <ng-container *ngFor="let department of departmentList">
                <mat-chip selected>{{department.name}}</mat-chip>
              </ng-container>
            </mat-chip-list>
          </app-detail>
        </div>
      </div>

    </mat-card>

  </div>
</div>
